import { render, staticRenderFns } from "./PriceMaintenance.vue?vue&type=template&id=67b2e634&scoped=true&"
import script from "./PriceMaintenance.vue?vue&type=script&lang=js&"
export * from "./PriceMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./PriceMaintenance.vue?vue&type=style&index=0&id=67b2e634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b2e634",
  null
  
)

export default component.exports